import BackBtn from "../../Components/BackButton/BackButton";
import AccessSentMailPopUp from "../../Features/Forms/Components/AccessSentMailPopUp/AccessSentMailPopUp";

function AccessSendMailPage() {
  return (
    <>
      <BackBtn></BackBtn>

      <AccessSentMailPopUp></AccessSentMailPopUp>
    </>
  );
}

export default AccessSendMailPage;
